import { newNotification } from "../../store"

export const openFileInput = (callback: (e: Event) => Promise<void>) => {
    const input = document.createElement("input")
    input.type = "file"
    input.accept = "image/*"
    input.multiple = true
    input.onchange = async (e: Event) => {
        await callback(e)
        setTimeout(() => {
            input.remove() // Delay the removal slightly
        }, 100)
    }
    input.click()
}

export const openCameraInput = (callback: (e: Event) => Promise<void>) => {
    const input = document.createElement("input")
    input.type = "file"
    input.accept = "image/*"
    input.capture = "environment"

    input.style.position = "absolute"
    input.style.left = "-9999px" // Hide the input off-screen
    document.body.appendChild(input)

    const handleChange = async (e: Event) => {
        console.log("HandleChange triggered") // Log to check if this triggers
        e.stopPropagation()
        await callback(e)

        setTimeout(() => {
            input.value = "" // Reset input
            input.remove() // Remove element
        }, 1000) // Delay removal
    }

    // Try using 'input' event listener as an alternative
    input.addEventListener("input", handleChange)

    input.focus()
    input.click()
}
